// extracted by mini-css-extract-plugin
export default {"book-cover":"styles_book-cover__cJ8ZK","no-margin-bottom":"styles_no-margin-bottom__uPylF","book-cover-img":"styles_book-cover-img__4ol3r"};